import React from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { Select } from '../../../components';
import { setUserValue } from '../../../store/slices/user';

import classes from './Business.module.scss';

const Business = ({ className }) => {
  const dispatch = useDispatch();

  const {
    profile: { roles },
    businesses,
    businessId
  } = useSelector(state => state.userData);

  const businessesOptions = Object.keys(businesses).map(businessId => {
    const { name, businessName, identificationNumber } = businesses[businessId].demography;
    return {
      value: businessId,
      label: `${name} - ${businessName} - ${identificationNumber}`
    };
  });

  const businessChangeHandler = ({ value }) => {
    dispatch(setUserValue({ key: 'businessId', value }));
  };

  const userRoles = roles ? roles : [];

  const containerClasses = [classes.container];
  if (className) {
    containerClasses.push(className);
  }

  return (
    userRoles.includes('accountant') && (
      <Select className={containerClasses.join(' ')} options={businessesOptions} value={businessId} onChange={businessChangeHandler} />
    )
  );
};

export default Business;
